module.exports = __webpack_public_path__ + "people_item_botoom.a638d801.png";